<template>
<div class="container-profile">
    <div id="home" class="animated-topbutton tamanhoicon" @click="$emit('backMenu'); somback()">
        <img :src="require('@/assets/buttons/newbuttons/black/home.svg')" />
    </div>
    <div class="profile-imagemdir">
        <img :src="require('@/assets/login_bonecos/dir.svg')" />
    </div>
    <div class="profile-imagemesq">
        <img :src="require('@/assets/login_bonecos/esq.svg')" />
    </div>
    <div class="container-elements">
        <span class="tamanhoicon elemento1" :class="{'sel-element' : selectedElement == 1 && escolheu==true}" @click="clickElement(1)">
            <img :src="require('@/assets/menu/profile_characters/oculos.png')">
        </span>
        <span class="tamanhoicon elemento2" :class="{'sel-element' : selectedElement == 2 && escolheu==true}" @click="clickElement(2)">
            <img :src="require('@/assets/menu/profile_characters/cachecol.png')">
        </span>
        <span class="tamanhoicon elemento3" :class="{'sel-element' : selectedElement == 3 && escolheu==true}" @click="clickElement(3)">
            <img :src="require('@/assets/menu/profile_characters/chapeu.png')">
        </span>
        <span class="tamanhoicon elemento4" :class="{'sel-element' : selectedElement == 4 && escolheu==true}" @click="clickElement(4)">
            <img :src="require('@/assets/menu/profile_characters/flor.png')">
        </span>
    </div>
    <div class="container-username">
        <span id="photo" @click="onClick(selected)">
            <img :src="require('@/assets/menu/profile_characters/' + selectedString + '.png')" style="width: 100%">
        </span>
        <span id="user" class="tamanhotitle">
            {{username}}
            <button class="button-profile tamanho0" @click="save">
                {{$t('menu.profile.save')}} </button>
        </span>

    </div>

</div>
</template>

<script>
export default {
    name: 'Profile',
    emits: ['backMenu', 'save'],
    components: {},
    data() {
        return {
            username: 'JOHNDOE',
            novoselected: '',
            selected: 0,
            selectedString: 0,
            selectedElement: 0,
            click: '',
            back: '',
            options: [{
                id: 0,
            }, {
                id: 1,
            }, {
                id: 2,
            }, {
                id: 3,
            }, {
                id: 4,
            }, {
                id: 5,
            }, {
                id: 6,
            }, {
                id: 7,
            }, {
                id: 8,
            }, {
                id: 9,
            }, ],
            aderecoEscolhido: 0,
            escolheu: false,
            count1: 0,
            count2: 0,
            count3: 0,
            count4: 0,

        };
    },
    props: {
        characterselected: Number,
        somTeclas: Boolean,
        user: Object
    },
    methods: {
        onClick() {
            this.selected += 1;
            if (this.selected >= 9) {
                this.selected = 0;
            }
            console.log(this.selected);
            this.selectedString = this.selected;
            this.somclick();
            this.escolheu = false;
            this.count1 = 0;
            this.count2 = 0;
            this.count3 = 0;
            this.count4 = 0;
        },
        save() {
            if (this.escolheu) {
                this.selected = this.aderecoEscolhido;
            }
            this.novoselected = this.selected;

            fetch(process.env.VUE_APP_API_URL + "/changeProfilePicture", {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Headers": "*",
                        Accept: "application/json, text/plain, *//**",
                    },
                    method: "POST",
                    body: JSON.stringify({
                        'user_id': this.user['id'],
                        'character_selected': this.selected,
                        'adereco_selected': this.aderecoEscolhido
                    })
                }).then((res) => {
                    return res.json();
                })
                .then((devs) => {
                    console.log(devs);
                    this.$emit('save', this.selected);
                    this.somclick();
                })
                .catch((error) => {
                    console.log(error);
                    error = true;
                });
        },
        somback() {
            if (this.somTeclas) {
                this.back.play();
            }
        },
        somclick() {
            if (this.somTeclas) {
                this.click.play();
            }
        },
        clickElement(num) {
            this.somclick();
            this.selectedElement = num;

            if (num == 1) {
                this.count1++;
                if (this.count4 > 0 || this.count2 > 0 || this.count3 > 0) {
                    this.count4 = 0;
                    this.count2 = 0;
                    this.count3 = 0
                }
                if (this.count1 % 2 == 0) {
                    this.escolheu = false;
                    this.count1 = 0;
                } else {
                    this.escolheu = true;
                }
            } else if (num == 2) {
                this.count2++;
                if (this.count1 > 0 || this.count4 > 0 || this.count3 > 0) {
                    this.count1 = 0;
                    this.count4 = 0;
                    this.count3 = 0
                }
                if (this.count2 % 2 == 0) {
                    this.escolheu = false;
                    this.count2 = 0;
                } else {
                    this.escolheu = true;
                }
            } else if (num == 3) {
                this.count3++;
                if (this.count1 > 0 || this.count2 > 0 || this.count4 > 0) {
                    this.count1 = 0;
                    this.count2 = 0;
                    this.count4 = 0
                }
                if (this.count3 % 2 == 0) {
                    this.escolheu = false;
                    this.count3 = 0;
                } else {
                    this.escolheu = true;
                }
            } else if (num == 4) {
                this.count4++;
                if (this.count1 > 0 || this.count2 > 0 || this.count3 > 0) {
                    this.count1 = 0;
                    this.count2 = 0;
                    this.count3 = 0
                }
                if (this.count4 % 2 == 0) {
                    this.escolheu = false;
                    this.count4 = 0;
                } else {
                    this.escolheu = true;
                }
            }

            if (this.escolheu) {
                if (num == 1) {
                    this.aderecoEscolhido = this.selected + 10;
                    this.selectedString = this.aderecoEscolhido;
                } else if (num == 2) {
                    this.aderecoEscolhido = this.selected + 20;
                    this.selectedString = this.aderecoEscolhido;

                } else if (num == 3) {
                    this.aderecoEscolhido = this.selected + 30;
                    this.selectedString = this.aderecoEscolhido;

                } else if (num == 4) {
                    this.aderecoEscolhido = this.selected + 40;
                    this.selectedString = this.aderecoEscolhido;
                }
            } else {
                if (num == 1) {
                    this.selectedString = this.selected;
                } else if (num == 2) {
                    this.selectedString = this.selected;
                } else if (num == 3) {
                    this.selectedString = this.selected;
                } else if (num == 4) {
                    this.selectedString = this.selected;
                }
            }
            console.log("selectedElement: " + this.selectedElement);
            console.log("escolheu: " + this.escolheu);
            console.log("selected: " + this.selected);
        }
    },
    created() {
        if (this.characterselected != '') {
            this.selected = this.characterselected;
            this.selectedString = this.selected;
        }
        console.log(this.characterselected);
        if (this.characterselected >= 10 && this.characterselected <= 19) {
            this.escolheu = true;
            this.selectedElement = 1;

        } else if (this.characterselected >= 20 && this.characterselected <= 29) {
            this.escolheu = true;
            this.selectedElement = 2;

        } else if (this.characterselected >= 30 && this.characterselected <= 39) {
            this.escolheu = true;
            this.selectedElement = 3;

        } else if (this.characterselected >= 40 && this.characterselected <= 49) {
            this.escolheu = true;
            this.selectedElement = 4;

        }
        if (this.selectedElement == 1) {
            this.aderecoEscolhido = this.selected;
            this.selectedString = this.aderecoEscolhido;
            this.selected = this.selected - 10;
        } else if (this.selectedElement == 2) {
            this.aderecoEscolhido = this.selected;
            this.selectedString = this.aderecoEscolhido;
            this.selected = this.selected - 20;
        } else if (this.selectedElement == 3) {
            this.aderecoEscolhido = this.selected;
            this.selectedString = this.aderecoEscolhido;
            this.selected = this.selected - 30;
        } else if (this.selectedElement == 4) {
            this.aderecoEscolhido = this.selected;
            this.selectedString = this.aderecoEscolhido;
            this.selected = this.selected - 40;
        }
        console.log("selected: " + this.selected);

    },
    mounted() {
        this.username = this.user['username'];
        console.log(this.user['profile']);
        if (this.user['profile']['character_selected'] != null) {
            this.selected = this.user['profile']['character_selected'];
            this.aderecoEscolhido = this.user['profile']['adereco_selected'];
        }

        this.click = new Audio(require('@/assets/sons/click.wav'));
        this.back = new Audio(require('@/assets/sons/back.flac'));
    }
};
</script>

<style>
.container-profile {
    pointer-events: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-family: Omnes;
    font-style: normal;
}

.container-profile>img {
    width: 100%;
    height: 100%;
    z-index: -1;
    object-fit: cover;
}

.container-profile>* {
    pointer-events: auto;
    flex-shrink: 0;
}

#complete {
    position: absolute;
    top: 64%;
    right: 42%;
}

.button-profile {
    background-color: rgba(255, 255, 255);
    border: black solid;
    border-radius: 80px;
    padding: 0.5rem;
    font-family: Omnes;
    font-weight: bold;
    width: 57%;
    z-index: 10;
    margin-top: 4%;
}

.container-elements {
    left: 17%;
    width: 13%;
    height: 100%;
    position: absolute;
    display: flex;
    /* font-size: 1.2em; */
    /* padding: 0.3em; */
    /* border-radius: 20px; */
    /* color: black; */
    align-items: center;
    -webkit-animation: movecontaineruser 0.5s ease-in-out;
    animation: movecontaineruser 0.5s ease-in-out;
    flex-direction: column;
    justify-content: center;
    z-index: 10;
}

.container-username {
    width: 45%;
    height: 100%;
    position: absolute;
    display: flex;
    font-size: 1.2em;
    /*padding: 0.3em;*/
    border-radius: 20px;
    color: black;
    align-items: center;
    animation: movecontaineruser 0.5s ease-in-out;
}

@keyframes movecontaineruser {
    0% {
        top: 70%;
    }

    100% {
        top: 0%;
    }
}

#user {
    margin-left: 7%;
    margin-top: 7%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    height: 18%;
    width: 40%;
}

#photo {
    margin-left: 3%;
    width: 45%;
}

#photo>img {
    border: 4px solid black;
    border-radius: 50%;

}

.profile-imagemdir {
    width: 28%;
    position: absolute;
    margin-right: 1%;
    right: 0;
    bottom: 0;
}

.profile-imagemesq {
    width: 25%;
    position: absolute;
    margin-left: 1%;
    left: 0;
    bottom: 0;
}

.elemento1>img,
.elemento2>img,
.elemento3>img,
.elemento4>img {
    box-shadow: 0 0 0 3px black;
    border-radius: 50%;
}

.elemento1 {
    margin-left: 50%;
}

.elemento4 {
    margin-left: 50%
}

.elemento3 {
    margin-top: 6%;
}

.sel-element>img {
    box-shadow: 0 0 0 5px black;
    border-radius: 50%;
}
</style>
